import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isIntegerValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value == null || value === '') return null;

    return Number.isInteger(value) ? null : { isNotInteger: true };
  };
}
